var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { color } from "../templates/ui";
import InputLabel from "./InputLabel";
import { firstError } from "../../Services/Form";
import ErrorLabel from "./ErrorLabel";
import _ from "lodash";
const StyledInputWrapper = styled.div `
    max-width: 100%;
    width: ${(props) => {
    if (props.fullWidth) {
        return "100%";
    }
    return "350px";
}};
`;
const StyledInput = styled.textarea `
    padding: 20px;
    margin: 0;
    background-color: transparent;
    border: 1px solid ${color.gray.light};
    width: 100%;
    min-height: 140px;
    box-sizing: border-box;
    outline: none;
    font-size: 15px;
    line-height: 1.2rem;
    color: ${color.base.base};
    border-radius: 7px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    resize: vertical;

    &::-webkit-input-placeholder {
        font-style: italic;
        color: ${color.gray.base};
    }

    &::-moz-placeholder {
        font-style: italic;
        color: ${color.gray.base};
    }

    &:-ms-input-placeholder {
        font-style: italic;
        color: ${color.gray.base};
    }

    &::placeholder {
        font-style: italic;
        color: ${color.gray.base};
    }

    &:disabled {
        background-color: #eeeeee;
        cursor: default;

        + label {
            opacity: 0.5;
        }
    }
`;
const InputTextArea = (_a) => {
    var { className, value, label, fullWidth, placeholder, tooltipContents, error } = _a, props = __rest(_a, ["className", "value", "label", "fullWidth", "placeholder", "tooltipContents", "error"]);
    error = typeof error === "object" ? firstError(error) : error;
    return (React.createElement(React.Fragment, null,
        React.createElement(InputLabel, { tooltipContents: tooltipContents }, label),
        React.createElement(StyledInputWrapper, { fullWidth: fullWidth },
            React.createElement(StyledInput, Object.assign({}, props, { placeholder: placeholder, value: value }))),
        !!error && React.createElement(ErrorLabel, null, _.capitalize(error))));
};
export default InputTextArea;
